import { render, staticRenderFns } from "./CongestionCard.vue?vue&type=template&id=613dd256&scoped=true"
import script from "./CongestionCard.vue?vue&type=script&lang=js"
export * from "./CongestionCard.vue?vue&type=script&lang=js"
import style0 from "./CongestionCard.vue?vue&type=style&index=0&id=613dd256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613dd256",
  null
  
)

export default component.exports